import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type SocialEngagePost from "./SocialEngagePost";

@Model()
class SocialEngagePostPerformance extends ApplicationRecord {
  static jsonapiType = "social_engage_post_performances";

  @Attr({ persist: false }) archived: boolean;

  @Attr({ persist: false }) archivedAt: string;

  @Attr() clicks: number;

  @Attr() comments: number;

  @Attr() deletedAt: string;

  @Attr() impressions: number;

  @Attr() label: string;

  @Attr() likes: number;

  @Attr() live: boolean;

  @Attr() organisationSocialIntegrationId: number;

  @Attr() performance: number;

  @Attr() permalink: string;

  @Attr() reach: number;

  @Attr() remoteId: string;

  @Attr() shares: number;

  @BelongsTo() socialEngagePost: SocialEngagePost;

  @Attr() socialPlatform: string;

  @Attr() token: string;

  @Attr({ persist: false }) updatedAt: string;

  platform() {
    switch (this.socialPlatform) {
      case "FacebookSocialIntegration":
        return "Facebook";
      case "TwitterSocialIntegration":
        return "Twitter";
      case "InstagramSocialIntegration":
        return "Instagram";
      case "LinkedinSocialIntegration":
        return "LinkedIn";
      default:
        return "";
    }
  }

  platformIcon(whiteIcon = false) {
    if (this.platform() === "Twitter")
      return `https://assets.streem.com.au/icons/twitter.svg`;

    const format = whiteIcon ? "15x15" : "";
    const iconName = this.platform().toLowerCase();

    return `https://assets.streem.com.au/icons/${iconName}${format}.svg`;
  }
}

export default SocialEngagePostPerformance;
